import { combineEpics } from 'redux-observable';

import { eLearningEpic } from './eLearning';
import { helpEpic } from './help';
import { routerEpic } from './router';

export { dependencies, EpicType } from './common';

// Epicの開始
export const rootEpic = combineEpics(eLearningEpic, helpEpic, routerEpic);



// WEBPACK FOOTER //
// ./src/epics/index.ts